<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-down-up-icon lucide-arrow-down-up">
      <path d="m3 16 4 4 4-4"/>
      <path d="M7 20V4"/>
      <path d="m21 8-4-4-4 4"/>
      <path d="M17 4v16"/>
    </svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
export default {
  name: 'IconSort',
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    return {
      width,
      isSmallScreen,
    }
  }
}
</script>